<template>
  <div>
    <v-flex>
      <h2>{{ $t("labels.selectOrganization") }}</h2>
    </v-flex>

    <v-list two-line style="max-height:600px; max-width:600px; overflow:auto" v-if="!isLoading">
      <template v-for="(item, index) in organizations">
        <v-subheader v-if="item.header" :key="item.header">
          {{ item.header }}
        </v-subheader>

        <v-divider v-else-if="item.divider" :inset="item.inset" :key="index"> </v-divider>

        <v-list-item v-else :key="item.id" @click="setOrganization(item)">
          <v-list-item-content>
            <v-list-item-title v-html="item.name"> </v-list-item-title>
            <v-list-item-subtitle v-html="item.email"> </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
    <v-layout v-else>
      <v-progress-linear indeterminate color="white" class="mb-0"> </v-progress-linear>
    </v-layout>

    <v-btn to="/login" class="mt-3" color="red" large block dark>{{ $t("buttons.cancel") }}</v-btn>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import userService from "../../User/service.js";

export default {
  name: "authentication-select-organization",
  props: ["Organizations"],
  data() {
    return {
      organizations: [],
      isLoading: true,
      noOrganization: false
    };
  },
  async created() {
    if (this.Organizations) {
      this.organizations = this.Organizations;
      this.isLoading = false;
    } else {
      // User ended up here maybe to change the org. Get list of organizations
      try {
        const response = await userService.getCurrent({ includeOrganizations: true });
        if (!response.data || !response.data.Organizations)
          throw new Error("Error getting organizations");
        if (response.data.Organizations.length === 0) {
          this.noOrganization = true;
        } else if (response.data.Organizations.length === 1) {
          this.setOrganization(this.setOrganization(response.data.Organizations[0]));
        } else {
          this.organizations = response.data.Organizations;
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
      }
    }
  },
  methods: {
    ...mapActions("global", ["initOrganization"]),
    async setOrganization(val) {
      await this.initOrganization(val)
        .then(() => {
          this.$router.push({ path: "/" });
        })
        .catch(error => {
          console.log(error);
        });
    },
    submit() {}
  }
};
</script>
